import { createSharedStockSlice, sharedStockInitialState } from '@/shared/modules/stock/business';
import { isStockBalanceColumnNumeric, isStockBalanceColumnSortingChanged } from './helpers';
const initialState = {
    ...sharedStockInitialState,
    useSalesStatistics: false,
    stockBalanceOptions: {
        filters: {
            brand: null,
            article: null,
            name: null,
            quantity: null,
            basePrice: null,
            customerPrice: null,
            marginPercent: null,
            margin: null,
            weeklySalesQuantity: null,
            weeklyUniqueCustomersQuantity: null,
            monthlySalesQuantity: null,
            monthlyUniqueCustomersQuantity: null,
        },
        ordering: [],
    },
    stockBalanceOptionsDialog: {
        open: false,
        column: null,
    },
    addDialog: {
        open: false,
    },
    editMarginDialog: {
        open: false,
    },
    editCostDialog: {
        open: false,
    },
    editQuantityDialog: {
        open: false,
    },
};
const stockSlice = createSharedStockSlice({
    name: 'stock',
    initialState,
    reducers: {
        setUseSalesStatistics: (state, action) => {
            state.useSalesStatistics = action.payload;
        },
        openStockBalanceOptionsDialog: (state, action) => {
            state.stockBalanceOptionsDialog.column = action.payload;
            state.stockBalanceOptionsDialog.open = true;
        },
        closeStockBalanceOptionsDialog: (state) => {
            state.stockBalanceOptionsDialog = initialState.stockBalanceOptionsDialog;
        },
        // // Old variant when multisorting works always. // TODO: to delete later if no needed.
        // toggleColumnSorting: (state, action: PayloadAction<StockBalanceFiltersKey>) => {
        // 	const currentSortingIndex = state.stockBalanceOptions.ordering.findIndex((item) => item.column === action.payload);
        // 	const currentSortingOrder = state.stockBalanceOptions.ordering[currentSortingIndex]?.order ?? null;
        // 	if (!currentSortingOrder) {
        // 		state.stockBalanceOptions.ordering.push({ column: action.payload, order: 'asc' });
        // 		return;
        // 	}
        // 	if (currentSortingOrder === 'asc') {
        // 		state.stockBalanceOptions.ordering[currentSortingIndex].order = 'desc';
        // 	} else if (currentSortingOrder === 'desc') {
        // 		state.stockBalanceOptions.ordering.splice(currentSortingIndex, 1);
        // 	}
        // },
        toggleColumnSorting: (state, action) => {
            // If shiftKey is pressed then other columns should be reset.
            const { columnKey, shiftKey } = action.payload;
            const sortingIndex = state.stockBalanceOptions.ordering.findIndex((item) => item.column === columnKey);
            const sortingOrder = state.stockBalanceOptions.ordering[sortingIndex]?.order ?? null;
            if (!sortingOrder) {
                if (!shiftKey) {
                    state.stockBalanceOptions.ordering = [];
                }
                state.stockBalanceOptions.ordering.push({ column: columnKey, order: 'asc' });
                return;
            }
            if (sortingOrder === 'asc') {
                if (shiftKey) {
                    state.stockBalanceOptions.ordering[sortingIndex].order = 'desc';
                }
                else {
                    state.stockBalanceOptions.ordering = [{ column: columnKey, order: 'desc' }];
                }
                return;
            }
            if (sortingOrder === 'desc') {
                if (shiftKey) {
                    state.stockBalanceOptions.ordering.splice(sortingIndex, 1);
                }
                else {
                    state.stockBalanceOptions.ordering = [];
                }
            }
        },
        setStockBalanceColumnOptions: (state, action) => {
            const { columnKey, formFields: { ascending, descending, stringFilter, numberFilterKey, numberFilterFrom, numberFilterTo }, } = action.payload;
            // Ordering
            const currentSortingIndex = state.stockBalanceOptions.ordering.findIndex((item) => item.column === columnKey);
            const currentSortingOrder = state.stockBalanceOptions.ordering[currentSortingIndex]?.order ?? null;
            // If ordering has not been changed, then multisorting should not be broken.
            if (isStockBalanceColumnSortingChanged(currentSortingOrder, ascending, descending)) {
                if (ascending || descending) {
                    state.stockBalanceOptions.ordering = [{ column: columnKey, order: ascending ? 'asc' : 'desc' }];
                }
                else {
                    state.stockBalanceOptions.ordering = [];
                }
            }
            // // Version with multisorting // TODO: to delete later if no needed.
            // if (ascending) {
            // 	if (!currentSortingOrder) {
            // 		state.stockBalanceOptions.ordering.push({ column: columnKey, order: 'asc' });
            // 	} else if (currentSortingOrder === 'desc') {
            // 		state.stockBalanceOptions.ordering[currentSortingIndex].order = 'asc';
            // 	}
            // } else if (descending) {
            // 	if (!currentSortingOrder) {
            // 		state.stockBalanceOptions.ordering.push({ column: columnKey, order: 'desc' });
            // 	} else if (currentSortingOrder === 'asc') {
            // 		state.stockBalanceOptions.ordering[currentSortingIndex].order = 'desc';
            // 	}
            // } else if (currentSortingIndex !== -1) {
            // 	state.stockBalanceOptions.ordering.splice(currentSortingIndex, 1);
            // }
            // Filters
            if (isStockBalanceColumnNumeric(columnKey)) {
                // @ts-expect-error why it is not working? It's nullable.
                state.stockBalanceOptions.filters[columnKey] =
                    numberFilterKey === null ||
                        (numberFilterKey !== null && numberFilterFrom === null) ||
                        (numberFilterKey === 'between' &&
                            (numberFilterFrom === null ||
                                numberFilterFrom === undefined ||
                                numberFilterTo === null ||
                                numberFilterTo === undefined))
                        ? null
                        : {
                            equals: numberFilterKey === 'equals' ? numberFilterFrom : null,
                            greaterOrEquals: numberFilterKey === 'greaterOrEquals' || numberFilterKey === 'between' ? numberFilterFrom : null,
                            greater: numberFilterKey === 'greater' ? numberFilterFrom : null,
                            lowerOrEquals: numberFilterKey === 'lowerOrEquals'
                                ? numberFilterFrom
                                : numberFilterKey === 'between'
                                    ? (numberFilterTo ?? null)
                                    : null,
                            lower: numberFilterKey === 'lower' ? numberFilterFrom : null,
                        };
            }
            else {
                // String column
                state.stockBalanceOptions.filters[columnKey] = {
                    includeValues: stringFilter,
                    excludeValues: [],
                };
            }
            state.stockBalanceOptionsDialog.open = false;
        },
        openStockItemAddDialog: (state) => {
            state.addDialog.open = true;
        },
        closeStockItemAddDialog: (state) => {
            state.addDialog.open = false;
        },
        openEditMarginDialog: (state) => {
            state.editMarginDialog.open = true;
        },
        closeEditMarginDialog: (state) => {
            state.editMarginDialog = initialState.editMarginDialog;
        },
        openEditCostDialog: (state) => {
            state.editCostDialog.open = true;
        },
        closeEditCostDialog: (state) => {
            state.editCostDialog = initialState.editCostDialog;
        },
        openEditQuantityDialog: (state) => {
            state.editQuantityDialog.open = true;
        },
        closeEditQuantityDialog: (state) => {
            state.editQuantityDialog = initialState.editQuantityDialog;
        },
    },
});
export const { actions: stockActions, reducer: stockStateReducer } = stockSlice;
